import { Injectable } from '@angular/core';
import { CanActivateChild } from '@angular/router';

import { AuthService } from '../../core';
import { AuthGuard } from '../../core/services/auth/auth-guard.service';
import { UsuarioPerfil, usuarioPerfilAdministrador, usuarioPerfilGerente, usuarioPerfilRepresentante, usuarioPerfilAtendente } from '../usuario/usuario-perfil';


/** Acessos permitidos as comissões */
export const acessosComissao: UsuarioPerfil[] = [usuarioPerfilAdministrador, usuarioPerfilGerente, usuarioPerfilAtendente, usuarioPerfilRepresentante];

@Injectable()
export class CanActivateComissao implements CanActivateChild {

    constructor(private authGuard: AuthGuard,
                private authService: AuthService) { }

    canActivateChild(): boolean {
        // Somente se o usuário possuir acesso ao recurso de comissões
        const usuario = this.authService.getUsuario();
        if (usuario && !usuario.acessoComissoes) {
            return false;
        }

        return this.authGuard.canActivateAcesso(acessosComissao);
    }
}
